export default __webpack_public_path__ + "night-stork-bg-2560x1600.4e95a2e.svg";